<template>
  <SignInSignUpLayout>
    <SignInForm v-if="isTenantDomain"/>
    <template v-else>
      <b-form
        @submit="forwardToTenantSubdomains"
        class="sing-in-form position-relative"
      >
        <Preloader v-if="isLoading" />
        <CompanyUrlPrefixField
          ref="prefixComponent"
          :companyPrefixGroupId="companyPrefixGroupId"
          :hideValidationErrors="!submitButtonPressed"
          :serverErrors="prefixServerErrors"
        />
        <b-button class="button confirm-button" type="submit" variant="primary">
          Go to tenant Sign In
        </b-button>
      </b-form>
    </template>
  </SignInSignUpLayout>
</template>

<script>
import SignInSignUpLayout from '@components/sign-up/SignInSignUpLayout.vue'
import SignInForm from '@components/sign-up/SignInForm.vue'
import CompanyUrlPrefixField from '@components/sign-up/CompanyUrlPrefixField.vue'
import Preloader from '@components/Preloader.vue'

export default {
  name: 'SignInPage',
  components: { Preloader, CompanyUrlPrefixField, SignInSignUpLayout, SignInForm },
  data () {
    return {
      isLoading: false,
      companyPrefixGroupId: 'company-prefix-group',
      prefixServerErrors: null,
      submitButtonPressed: false
    }
  },
  created () {
    if (this.$cookies.get('tenant_signup_confirm_token')) {
      this.firstTenantSignIn()
    }
  },
  methods: {
    firstTenantSignIn () {
      this.axios
        .get('/api/register/first-tenant-sign-in')
        .then((response) => {
          const user = response.data.user.original
          this.authUserAtFrontEnd(response.data.access_token, response.data.refresh_token, user, user.user_roles)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    forwardToTenantSubdomains (e) {
      e.preventDefault()

      this.submitButtonPressed = true
      this.prefixServerErrors = null

      this.$refs.prefixComponent.$v.$touch()
      if (this.$refs.prefixComponent?.$v.$invalid) {
        return
      }

      this.axios
        .get('/api/get-tenant-sign-in-page/' + this.$refs.prefixComponent.prefix)
        .then(({ data }) => {
          document.location.href = data.url
        })
        .catch((error) => {
          this.prefixServerErrors = Object.values(error.response.data.errors)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
